import { SearchInput } from "components";
import Loader from "components/layout/loader";
import { FC } from "react";
import ClaimCard from "./ClaimCard";
import { ClaimData } from "graphql/__generated__/globalTypes";

interface ClaimsGridProps {
  claims: ClaimData[];
  searchValue: string;
  search: (value: string) => void;
  loading: boolean;
  error?: Error;
  refresh?: () => void;
  statusFilter: string;
  onStatusFilterChange: (status: string) => void;
}

const ClaimsGrid: FC<ClaimsGridProps> = ({
  claims,
  searchValue,
  search,
  loading,
  error,
  refresh,
  statusFilter,
  onStatusFilterChange,
}) => {

  return (
    <div className="w-full">
      <div className="flex flex-wrap items-center justify-between mb-6 gap-4">
        <SearchInput
          placeholder="Search claims by reference or offer..."
          value={searchValue}
          onChange={search}
          className="w-64"
        />

        <div className="flex flex-wrap gap-4 items-center">
          {refresh && (
            <button
              onClick={refresh}
              className="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors text-sm font-medium"
            >
              Refresh
            </button>
          )}
        </div>
      </div>

      {loading ? (
        <Loader card />
      ) : error ? (
        <div className="bg-red-50 border border-red-200 rounded-lg p-6 text-center">
          <p className="text-red-800 font-medium mb-2">Error loading claims</p>
          <p className="text-red-600 text-sm">{error.message}</p>
          {refresh && (
            <button
              onClick={refresh}
              className="mt-4 px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 transition-colors text-sm font-medium"
            >
              Try Again
            </button>
          )}
        </div>
      ) : claims.length === 0 ? (
        <div className="bg-gray-50 border border-gray-200 rounded-lg p-12 text-center">
          <p className="text-gray-600 text-lg mb-2">No claims found</p>
          <p className="text-gray-500 text-sm">
            {searchValue
              ? "Try adjusting your search or filters"
              : "You don't have any claims yet"}
          </p>
        </div>
      ) : (
        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6">
          {claims.map((claim) => (
            <ClaimCard
              key={claim.offer_claim_id}
              claim={claim}
              status={statusFilter === "All" ? "Open" : statusFilter}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default ClaimsGrid;
